import { Button } from "@renderbus/ui";
import ClearIcon from "@renderbus/ui/assets/svg/clearIcon";
import styled from "styled-components";

export function ClearBtn({ onClick }: { onClick?: () => void }) {
  return <ClearButton onClick={onClick} size={"middle"} icon={<ClearIcon />} />;
}

const ClearButton = styled(Button)`
  display: flex;
  align-items: center;
  justify-content: center;
  background: #333336;
  border-color: #333336;
  &:hover {
    background: #333336;
    border-color: #5c5c5e;
  }
  &:active,
  &:focus {
    background: #5c5c5e;
    border-color: #5c5c5e;
  }
`;
